module.exports = __webpack_public_path__ + "img/venezuela.4915be03.webp";